import {useInjection} from 'dna-react-ioc'
import {INotificationStore} from '@/layouts/INotificationStore'
import {AuthNotificationStoreSymbol, NotificationStoreSymbol} from '@/layouts'

export const useNotificationStore = () => useInjection<INotificationStore>(NotificationStoreSymbol)
export const useAuthNotificationStore = () =>
    useInjection<INotificationStore>(AuthNotificationStoreSymbol)
